/*
 * Non-secure storage for push notification debug log
 */
import AsyncStorage from '@react-native-async-storage/async-storage';

export type PushNotificationLogEntry = {
    timestamp: string;
    actionIdentifier: string;
    data: unknown;
    resolvedUrl: string | null;
    openLinkError: string | null;
};

const KEY = 'push-notifications-log';
const MAX_ENTRIES = 20;

export const getPushNotificationLog = async (): Promise<PushNotificationLogEntry[]> => {
    const raw = await AsyncStorage.getItem(KEY);
    if (!raw) {
        return [];
    }
    try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? (parsed as PushNotificationLogEntry[]) : [];
    } catch {
        return [];
    }
};

export const appendPushNotificationLogEntry = async (entry: PushNotificationLogEntry): Promise<void> => {
    const current = await getPushNotificationLog();
    const next = [entry, ...current].slice(0, MAX_ENTRIES);
    await AsyncStorage.setItem(KEY, JSON.stringify(next));
};

export const clearPushNotificationLog = async (): Promise<void> => AsyncStorage.removeItem(KEY);
